// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import createClaimModal from './create-claim';
import facets from './facets';
import filteredSearchResults from './filtered-search-results';
import reportsAccordion from './reports-accordion';
import reviseClaim from './revise-claim';
import searchByDropDown from '../../shared/reducers/search-by-dropdown';
import searchFilters from './search-filters';
import searchQueryString from '../../shared/reducers/search-query-string';
import searchResults from './search-results';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    createClaimModal,
    facets,
    filteredSearchResults,
    reportsAccordion,
    reviseClaim,
    searchByDropDown,
    searchFilters,
    searchQueryString,
    searchResults
});



// WEBPACK FOOTER //
// ./src/claim/claim-search/reducers/index.js